import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
// import PortfolioSectionS3 from '../../components/PortfolioSectionS3/PortfolioSectionS3';
// import SectionTitle from "../../components/SectionTitle";

// const instructions = "Sube aquí las fotos de la boda para compartir y que todo el mundo las vea"

const AboutPage = () => {
    const driveLink = "https://drive.google.com/drive/folders/1oRtuw-2GFvQ9c5SP7YfuAWlXkJWmSFQK?usp=sharing";

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-3'}/>
            <PageTitle pageTitle={'Sube tus fotos'} pagesub={'Sube tus fotos'} />
            {/* <SectionTitle MainTitle={'Sube tus fotos de la boda'} s2Class={'mt-5'} /> */}
            
            <section className="wpo-about-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="drive-upload-section" style={{
                                textAlign: 'center',
                                padding: '40px 20px',
                                backgroundColor: '#f8f8f8',
                                borderRadius: '10px',
                                marginTop: '40px',
                                marginBottom: '40px'
                            }}>
                                <div style={{ marginBottom: '30px' }}>
                                    <h1 style={{ 
                                        // fontSize: '24px', 
                                        fontWeight: '600', 
                                        color: '#333',
                                        marginBottom: '20px'
                                    }}>
                                        Comparte tus momentos especiales
                                    </h1>
                                    <p style={{ 
                                        fontSize: '20px', 
                                        color: '#666',
                                        lineHeight: '1.8',
                                        marginBottom: '15px'
                                    }}>
                                        Queremos que todos puedan ver y disfrutar de las fotos de nuestra boda. 
                                        Por favor, sube las fotos que hayas tomado a nuestra carpeta compartida en Google Drive.
                                    </p>
                                    <p style={{ 
                                        fontSize: '20px', 
                                        color: '#666',
                                        lineHeight: '1.8',
                                        marginBottom: '30px'
                                    }}>
                                        <strong>Instrucciones:</strong> Haz clic en el botón de abajo para acceder a la carpeta. 
                                        Luego, simplemente arrastra tus fotos o haz clic en "Nuevo" para subirlas.
                                    </p>
                                </div>
                                <a 
                                    href={driveLink} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="theme-btn"
                                    style={{
                                        display: 'inline-block',
                                        textDecoration: 'none',
                                        marginTop: '20px'
                                    }}
                                >
                                    📁 Abrir carpeta de Google Drive
                                </a>
                                
                                <div style={{
                                    marginTop: '40px',
                                    padding: '25px',
                                    backgroundColor: '#fff3cd',
                                    border: '2px solid #ffc107',
                                    borderRadius: '8px',
                                    textAlign: 'left'
                                }}>
                                    <h3 style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#856404',
                                        marginBottom: '15px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        ⚠️ ¿Problemas para subir tus fotos?
                                    </h3>
                                    <p style={{
                                        fontSize: '16px',
                                        color: '#856404',
                                        lineHeight: '1.8',
                                        marginBottom: '15px'
                                    }}>
                                        Si al intentar subir tus fotos ves un mensaje que dice <strong>"El almacenamiento está lleno"</strong> o <strong>"No tienes suficiente espacio de almacenamiento"</strong>, no te preocupes. Esto significa que tu cuenta de Google Drive ya no tiene espacio disponible.
                                    </p>
                                    <p style={{
                                        fontSize: '16px',
                                        color: '#856404',
                                        lineHeight: '1.8',
                                        marginBottom: '20px'
                                    }}>
                                        <strong>Alternativa fácil:</strong> Puedes compartir tus fotos usando nuestro formulario. Solo haz clic en el botón de abajo, completa el formulario y sube tus fotos desde ahí. No ocupará espacio en tu cuenta de Google y en cuanto podamos nosotrxs las subiremos a la carpeta compartida.
                                    </p>
                                    <a 
                                        href="https://docs.google.com/forms/d/e/1FAIpQLSeWnbmVQboK3aEwAyx1oUrVQCULQ3rFSFv2o0dzV-9GkklZNw/viewform?usp=header"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="theme-btn"
                                        style={{
                                            display: 'inline-block',
                                            textDecoration: 'none',
                                            backgroundColor: '#ffc107',
                                            color: '#856404',
                                            border: 'none',
                                            fontSize: '12px'
                                        }}
                                    >
                                        📝 Subir fotos mediante formulario
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <PortfolioSectionS3/> */}
            <Footer footerClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};

export default AboutPage;
